import { render } from "./SchedulesSpecialtyBoard.vue?vue&type=template&id=25ed217f&scoped=true"
import script from "./SchedulesSpecialtyBoard.vue?vue&type=script&lang=js"
export * from "./SchedulesSpecialtyBoard.vue?vue&type=script&lang=js"

import "./SchedulesSpecialtyBoard.vue?vue&type=style&index=0&id=25ed217f&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ed217f"]])

export default __exports__